import { motion } from "framer-motion";
import Seo from "../components/Seo";
import { DEFAULT_DESCRIPTION } from "../lib/siteConfig";
import { BOOK_DEMO_URL } from "../lib/constants";
import FreeScanBanner from "../components/FreeScanBanner";
import AttackNarrative from "../components/AttackNarrative";
import StatsStrip from "../components/StatsStrip";
import PillarsTeaser from "../components/PillarsTeaser";
import TrustMarquee from "../components/TrustMarquee";

export default function Home() {
  return (
    <main className="flex-grow">
      <Seo
        title="AI-Driven Cyber Risk Intelligence Platform"
        description={DEFAULT_DESCRIPTION}
        path="/"
      />

      <section className="w-full px-gutter max-w-container-max mx-auto pt-16 md:pt-section-gap pb-16 flex flex-col items-center text-center relative">
        <span className="font-eyebrow text-eyebrow text-primary uppercase tracking-widest mb-stack-lg">
          Cyber Risk Intelligence
        </span>
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="font-display-hero-mobile md:font-display-hero text-display-hero-mobile md:text-display-hero text-on-surface dark:text-surface-bright max-w-4xl mb-stack-lg"
        >
          See Cyber Risk Before It Becomes an Attack
        </motion.h1>
        <p className="font-body-lg text-body-lg text-on-surface-variant dark:text-surface-variant max-w-2xl mb-stack-lg">
          One score. Every signal. Attack surface, digital risk, and compliance — unified.
          Traditional tools show you noise after the fact. Cybermon shows you risk before it
          becomes a breach.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-primary-container text-on-primary-container font-headline-card text-headline-card px-8 py-4 rounded-DEFAULT shadow-sm hover:scale-105 transition-transform flex items-center gap-2"
          >
            Book a Demo
            <span className="material-symbols-outlined text-[20px]">arrow_forward</span>
          </a>
        </div>
        <motion.div
          animate={{ y: [0, 6, 0] }}
          transition={{ repeat: Infinity, duration: 1.8 }}
          className="mt-16 md:mt-section-gap flex flex-col items-center text-on-surface-variant dark:text-surface-variant opacity-60"
        >
          <span className="font-label-sm text-label-sm uppercase tracking-widest mb-2">
            Scroll to see how a breach happens
          </span>
          <span className="material-symbols-outlined">arrow_downward</span>
        </motion.div>
      </section>

      <FreeScanBanner />
      <AttackNarrative />
      <StatsStrip />
      <PillarsTeaser />
      <TrustMarquee />
    </main>
  );
}
